/**
 * Created by tj on 2018/3/5.
 */
import Signal from 'signals';
const myObject = {
      started: new Signal(),
      channelSignal: new Signal(),
      specificationSignal: new Signal()
}
export default myObject


// WEBPACK FOOTER //
// ./src/utils/signals.js